import { behindScenes } from "@/mocks/lustCaution";

export default function Behind() {
  return (
    <section id="behind" className="w-full bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <p className="text-primary-600 font-label text-sm tracking-widest uppercase">Behind</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug">
              幕后与版本之争
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              版本差异之所以被反复讨论，不只是尺度问题，也关乎创作、分级与观众理解之间的关系。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {behindScenes.map((item) => (
              <div
                key={item.title}
                className="flex gap-4 md:gap-5 rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
              >
                <span className="w-12 h-12 md:w-14 md:h-14 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}